import React, { useState, useEffect } from "react";
import { FaPhoneAlt, FaWhatsapp, FaArrowUp, FaPlus } from "react-icons/fa";

const FloatingButtons = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const checkScrollTop = () => {
      setShowTopBtn(window.scrollY > 200);
    };
    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      {/* Floating WhatsApp and Phone Buttons - Left Side */}
      <div className="fixed left-3 bottom-14 z-50 sm:left-5 sm:bottom-16 flex flex-col gap-3">
        <a
          href="tel:+919818922508"
          className="bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg animate-slide-in"
          title="Call Now"
        >
          <FaPhoneAlt className="w-5 h-5" />
        </a>
        <a
          href="https://wa.me/919818922508"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-600 hover:bg-green-700 text-white p-3 rounded-full shadow-lg animate-slide-in"
          title="WhatsApp"
        >
          <FaWhatsapp className="w-6 h-6" />
        </a>
      </div>

      {/* Scroll-to-top Button - Right Side */}
      {showTopBtn && (
        <button
          onClick={scrollToTop}
          className="fixed opacity-90 right-3 bottom-14 sm:right-5 sm:bottom-16 bg-gray-700 hover:bg-gray-900 text-white p-4 rounded-full z-50 shadow-lg"
          title="Scroll to Top"
        >
          <FaArrowUp className="w-5 h-5" />
        </button>
      )}
    </>
  );
};

export default FloatingButtons;
